import React, { useEffect, useState } from "react";
import CustomTable from "../CustomTable";
import CustomButton from "../CustomButton";
import moment from "moment";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import DatePicker from "../FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { useNavigate } from "react-router-dom";
import { debounce } from "../../utils/helpers";
import useDebounce from "../../hooks/useDebounce";
import { useAuth } from "../../contexts/AuthContext";
import { downloadReportsFun } from "../../../srcWeb/utils/helpers";

const SavedVouchers = () => {
  const { data = [], apiCall } = useApi();
  const { apiCall: fileDownload } = useApi();
  const { apiCall: DeleteVoucher } = useApi();

  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 500);

  const {
    selectedStores,
  } = useAuth();
  const { storeCode = ""} = selectedStores?.storeDetails || {}
  

  const savedVoucherApi = () => {
    if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        method: "post",
        dataToSend: {
          startDate: moment().startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 4,
          endDate: moment().endOf("d").format("YYYY-MM-DD HH:mm:ss"),
          searchText: debouncedSearchText,
        },
        processData: (apiData) => {
          return apiData?.[0]?.documents?.map((item) => {
            let obj = {};
            item?.dataModalAttributeSet?.forEach((data) => {
              obj[data?.metadataTechnicalName] = data?.attributeValue;
              if (data?.id) {
                obj.id = data?.id;
              }
              if (item?.id) {
                obj.file_id = item?.id;
              }
  
              if (item?.documentName) {
                obj.filename = item?.documentName;
              }
            });
  
            return obj;
          });
        },
      });
    }
  }
  useEffect(() => {
    savedVoucherApi();
  }, [debouncedSearchText]);

  const onClickDownloadFile = (file_id, filename) => {
    fileDownload({
      url: apiUrls.dmsService.getFile + "/" + file_id,
      method: "get",
      responseType: "blob",
      onSuccess: (apiData) => {
        const url = window.URL.createObjectURL(new Blob([apiData.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      },
    });
  };

  const deleteVoucher = (voucher_id) => {
    DeleteVoucher({
      url: apiUrls.dmsService.deleteVoucher + "/" + voucher_id,
      method: "delete",
      onSuccess: () => {
        // toast.success("Successfully Delete Voucher");
        savedVoucherApi();
      },
    });
  }

  const columns = [
    {
      Header: "Date",
      accessor: "date",
      Cell: (rowData) => {
        return <div>{rowData?.date}</div>;
      },
    },
    {
      Header: "Voucher Head",
      accessor: "head",
      Cell: (rowData) => {
        const value = rowData;

        return (
          <div className="py-4">
            <div className="font-size-small">{value?.head}</div>
            {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.sub_head}
            </div> */}
          </div>
        );
      },
    },
    {
      Header: "Amount (₹)",
      accessor: "amount",
      Cell: (rowData) => {
        const value = rowData?.amount;
        let amount;
        if(typeof value == "string"){
          amount = Number(value).toFixed(2);
        } else {
          amount = value
        }
        return amount || "-";
      },
    },
    {
      Header: "Voucher Comment",
      accessor: "comment",
    },
    {
      Header: "",
      accessor: "file_id",
      Cell: (rowData) => {
        return (
          <div className="flex items-center gap-x-7">
            <img
              alt="attachment icon"
              className="cursor-pointer"
              src={icons.downloadIcon}
              onClick={() =>
                onClickDownloadFile(rowData?.file_id, rowData?.filename)
              }
            />
            <img
              alt="attachment icon"
              className="cursor-pointer"
              src={icons.trashIcon}
              onClick={() =>
                deleteVoucher(rowData?.file_id)
              }
            />
          </div>
        );
      },
    },
  ];

  // const onClickSingleDownloadFile = () => {
  //   // const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
  //   // const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
  //   fileDownload({
  //     url: `${apiUrls.dmsService.getDownloadVoucherReport}`,
  //     // dataToSend: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
  //     dataToSend: {
  //       voucherIds: selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
  //       status: "Saved",
  //     },
  //     method: "post",
  //     responseType: "blob",
  //     responseData: (res) => {
  //       const { data = "", status = null } = res || {};
  //       const contentType = res?.headers?.["content-type"];
  //       const contentDisposition = res?.headers["content-disposition"];
  //       const fileNameMatch =
  //         contentDisposition && contentDisposition.match(/filename="(.+)"/);
  //       const fileName = fileNameMatch
  //         ? fileNameMatch[1]
  //         : "downloaded-file.xlsx";
  //       if(status === 200) {
  //         toast.success("Download File Successfully");
  //         downloadReportsFun(data, "AllVoucher.xlsx", contentType);
  //       } else {
  //         toast.success("Something Went Wrong");
  //       }
  //     },
  //   });
  // };

  return (
    <div className="flex flex-col py-2">
      <div className="flex justify-between mt-2 mb-8">
        <InputWithIcon
          placeholder="Search Vouchers"
          containerClassName="search-input-wrapper"
          wrapperClassName="!h-[4rem]"
          inputClassName="font-size-small"
          rightIcon={icons.searchIcon}
          onChange={(e) => setSearchText(e)}
          value={searchText}
        />
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>
          <DatePicker />
        </div>
      </div>
      <CustomTable
        data={data}
        columns={columns}
        showCheckboxes={true}
        onCheckboxSelect={(selectedCheckBoxes) => {
          console.log(selectedCheckBoxes, "selectedCheckBoxes");
        }}
        centerAlignedColumns={["amount"]}
      />
      <div className="flex items-center self-end mt-5 gap-x-6">
        <CustomButton
          title="Edit Voucher"
          wrapperClassName="!px-10"
          onClick={() => {
            navigate("/vouchers/edit", { state: { isEditFeatureOn: true } });
          }}
        />
        <CustomButton title="Download" wrapperClassName="!px-10" />
        {/* <CustomButton title="Send For Approval" wrapperClassName="!px-10" /> */}
      </div>
    </div>
  );
};

export default SavedVouchers;
